import logo from "assets/images/bmd-logo.png";
import { message } from "antd";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { chatStore } from "store/chatStore";
import { userStore } from "store/userStore";
import type { Staff } from "types/staff";
import { getTitle } from "utils";
import LoginForm from "views/Login/components/Form";
import LoginTitle from "views/Login/components/LoginTitle";
import "./styles/LoginPage.scss";

type LoginPageProps = {
  title?: string;
};

const LoginPage = observer(({ title = "" }: LoginPageProps) => {
  const [loading, setLoading] = useState(false);
  const navigation = useNavigate();

  useEffect(() => {
    document.title = getTitle(title);
  }, [title]);

  const handleSubmit = async (form: { username: string; password: string }) => {
    setLoading(true);
    try {
      await userStore.login(form.username, form.password);
      await userStore.getProfile();
      chatStore.initFromProfile(userStore.info as Staff);
      if (chatStore.selectedProjectId) {
        await chatStore.fetchConversations(chatStore.selectedProjectId);
      }
      navigation("/");
    } catch (error: unknown) {
      const err = error as { response?: { data?: { message?: string } }; message?: string };
      message.error(err?.response?.data?.message || err?.message || "Đăng nhập thất bại");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__card">
        <div className="login-page__logo-wrap">
          <img src={logo} alt="BMD Chat AI" className="login-page__logo" />
        </div>

        <LoginTitle title="BMD Chat AI" subtitle="Đăng nhập" />

        <LoginForm loading={loading} onSubmit={handleSubmit} />
      </div>
    </div>
  );
});

export default LoginPage;
